<template>
  <div>
    <ListItemFilters
      icon="ui-icon-plus"
      :title="doctorFiltersState.otherSpeciality?.name || t('Дополнительная специальность', options)"
      :subtitle="doctorFiltersState.otherSpeciality ? t('Дополнительная специальность', options) : ''"
      @click="openDialog"
    />

    <SpecialityModal
      :value="isDialogOpened"
      is-back
      :title="t('Доп. специальность', options)"
      :placeholder="t('Специальность', options)"
      title-truncate
      is-visible-reset
      :town-id="commonStore.town.id"
      :town-translit="commonStore.town.translit"
      :is-doctor-list-home="doctorFiltersState.visitLocation === 'home'"
      :is-doctor-list-online="doctorFiltersState.visitLocation === 'online'"
      :selected-speciality="filtersStore.unsavedFilters.otherSpeciality"
      :excluded-speciality="doctorFiltersState.speciality"
      :patient-age="doctorFiltersState.patientAge"
      @speciality:selected="onClickSpeciality"
      @speciality:reset="onResetSpeciality"
      @input="handleCloseSpecialityModal"
    >
      <template #footer="{ selectedSpeciality }">
        <div class="pa-2 elevation-8">
          <v-btn
            block
            depressed
            color="primary"
            :disabled="!hasUnsavedSpeciality"
            @click="handleSpecialitySelected(selectedSpeciality)"
          >
            {{ t('Применить', options) }}
          </v-btn>
        </div>
      </template>
    </SpecialityModal>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import deepEqual from 'www/vue_components/common/TheFilters/doctors/functions/deepEqual'
import useCommonStore from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import ListItemFilters from 'www/vue_components/common/TheFilters/common/components/ListItemFilters/ListItemFilters.vue'
import SpecialityModal from 'www/vue_components/common/TheFilters/doctors/components/SpecialityFilters/components/SpecialityModal.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const commonStore = useCommonStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ListItemOtherSpeciality')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: doctorFiltersState } = toRefs(props)

const hasUnsavedSpeciality = computed(() => (
  !deepEqual(doctorFiltersState.value.otherSpeciality, filtersStore.unsavedFilters.otherSpeciality)
))

const handleCloseSpecialityModal = () => {
  closeDialog()
  filtersStore.updateUnsavedFilters(doctorFiltersState.value)
}

const handleSpecialitySelected = (speciality?: Filters['speciality']) => {
  closeDialog()

  emit('input', {
    ...doctorFiltersState.value,
    otherSpeciality: speciality
      ? {
        id: speciality.id,
        name: speciality.name,
        translit: speciality.translit,
      }
      : undefined,
  })
}

const onClickSpeciality = (speciality: Filters['speciality']) => {
  filtersStore.updateUnsavedFilters({
    otherSpeciality: {
      id: speciality.id,
      name: speciality.name,
      translit: speciality.translit,
    },
  })
}

const onResetSpeciality = () => {
  filtersStore.updateUnsavedFilters({ otherSpeciality: undefined })
  handleSpecialitySelected(undefined)
}
</script>
